import { isEqual } from 'lodash';
import React, { useEffect, useState } from 'react';
import { PrescriptionStatusChart } from './PrescriptionStatusChart';

interface IPropsType {
  id: string;
  status: ICircleChartStatusType;
  customStyle: string;
  chartConfig: Record<string, any>;
}

export const EMPTY_CHART_STATUS = (unit: string): ICircleChartStatusType => ({
  isExpired: false,
  remainingDaysChart: 0,
  remainingPercentage: 0,
  unit: `DAYS<br/>${unit}`,
});

export const createSeries = (status: ICircleChartStatusType) => {
  return {
    name: status.unit,
    data: [
      {
        radius: '100%',
        innerRadius: '100%',
        y:
          status.remainingPercentage !== 0
            ? 100 - status.remainingPercentage
            : 100,
        x: status.remainingDaysChart,
      },
    ],
  };
};

const CircleChart = (props: IPropsType) => {
  const { id, status, chartConfig, customStyle } = props;
  const [previousStatus, setPreviousStatus] =
    useState<ICircleChartStatusType | null>(null);

  const { isExpired } = status;

  useEffect(() => {
    if (!isEqual(previousStatus, status)) {
      setPreviousStatus(status);
      const chart = new PrescriptionStatusChart(id, isExpired, chartConfig);
      chart.drawChart();
      chart.addSeries(createSeries(status));
    }
  }, [id, isExpired, chartConfig, status, previousStatus]);

  return <div id={id} className={customStyle} data-testid="circle-chart-id" />;
};

export default CircleChart;
